import { Injectable, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { NavLink, SvgIcon } from "src/app/core";
import { SidenavService } from "src/app/shared";
import { VenueBasic } from "../../venues";
import { VenueAdminService } from "./venue-admin.service";

@Injectable()
export class VenueAdminSidenavService extends SidenavService implements OnDestroy {
  private _destroyed$: Subject<void> = new Subject<void>();

  constructor(private _venueAdminService: VenueAdminService) {
    super();

    this._venueAdminService.activeVenue$.pipe(takeUntil(this._destroyed$)).subscribe({
      next: venue => {
        if (venue) {
          this._setState(venue);
        }
      },
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  navigateTo3D(matDialog: MatDialog, route: ActivatedRoute): boolean {
    return false;
  }

  shareButtonDialog(): void {}

  private _setState(venue: VenueBasic): void {
    this.setNavLinks(this._makeNavLinks(venue), null);
  }

  private _makeNavLinks(venue: VenueBasic): NavLink[] {
    const navLinks = [
      new NavLink({
        label: "Overview",
        path: "./overview",
        icon: SvgIcon.dashboard_outline,
      }),
      new NavLink({
        label: "Venue Info",
        path: "./venue-info",
        icon: SvgIcon.corporate_fare,
      }),
      new NavLink({
        label: "Rooms",
        path: "./rooms",
        icon: SvgIcon.meeting_room,
        disabled: venue.rooms.length === 0,
        toolTip: venue.rooms.length === 0 ? "Venue has no rooms" : null,
      }),
      new NavLink({
        label: "Inventory",
        path: "./inventory",
        icon: SvgIcon.chair_alt,
      }),
      new NavLink({
        label: "Templates",
        path: "./templates-presets",
        icon: SvgIcon.grid_view,
        disabled: !venue.is3dModelReady,
        toolTip: !venue.is3dModelReady ? "3D model pending" : null,
      }),
      new NavLink({
        label: "Cameras",
        path: "./cameras",
        icon: SvgIcon.cameraswitch,
        disabled: !venue.is3dModelReady,
        toolTip: !venue.is3dModelReady ? "3D model pending" : null,
      }),
    ];

    return navLinks;
  }
}
